import { authorizedApiClient } from "../config";
import type {
  HealthScoreSettings,
  HealthScoreSettingsRequest,
  UpdateHealthScoreSettingsRequest,
} from "./healthScoreSettingsEndpoints.interface";

export const readHealthScoreSettings = async ({ workspace_id }: HealthScoreSettingsRequest) =>
  authorizedApiClient.get<HealthScoreSettings>(`/${workspace_id}/health-score-settings`);

export const updateHealthScoreSettings = async ({
  workspace_id,
  payload,
}: UpdateHealthScoreSettingsRequest) =>
  authorizedApiClient.put<HealthScoreSettings>(`/${workspace_id}/health-score-settings`, payload);
